// extracted by css-extract-rspack-plugin
export default {"cls1":"OnboardingTour-cls1_xXS","cls2":"OnboardingTour-cls2_Dwu OnboardingTour-cls1_xXS"};